import { IGameState } from 'State/Game/IGameState';
import CardStateHelper, { getCardsState, ISetCardInStackRandomlyOptions } from '../CardStateHelper';
import BaseModifierBehavior from './BaseModifierBehavior';

export default class ToStackModifierBehavior extends BaseModifierBehavior {
    public onOwnCardPlayed(state: IGameState): IGameState {
        return this.addCardToStack(state);
    }

    public onOwnCardDiscarded(state: IGameState): IGameState {
        return this.addCardToStack(state);
    }

    private addCardToStack(state: IGameState): IGameState {
        if (this.modifier.properties.rewardGiven) return state;

        const rewardCardID: string = this.modifier.properties.cardID;
        const cardBehavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, rewardCardID);
        const options: ISetCardInStackRandomlyOptions = this.modifier.properties.options;

        state = CardStateHelper.setCardInStackRandomly(state, rewardCardID, options);

        state = cardBehavior.onAddedToStack(state);

        let cardsState = getCardsState(state);
        cardsState = CardStateHelper.clearUndoHistory(cardsState);
        cardsState = this.updateModifier(cardsState, this.cardID, {
            properties: {
                ...this.modifier.properties,
                rewardGiven: true,
            },
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
